<!--
 * @Author: van
 * @Date: 2021-08-19 09:19:10
 * @LastEditors: van
 * @LastEditTime: 2021-10-06 18:29:18
-->
<template>
  <el-popconfirm class="delPopConfirm"
                 :confirm-button-text="confirmButtonText"
                 :cancel-button-text="cancelButtonText"
                 icon="el-icon-info"
                 icon-color="red"
                 hide-icon
                 :title="title || ($i18n.locale=='zh'?`确定${item.name}?`:`${item.name},Continue?`)"
                 @confirm="confirm">
    <el-button slot="reference"
               :class="[item.type !== 'text'?btnClassName:'',item.class]"
               :size="item.size?item.size:'mini'"
               :type="item.type?item.type:item.class">{{item.name}}</el-button>
  </el-popconfirm>
</template>

<script>
export default {
    props: {
        confirmButtonText: {
            type: String,
            default: "",
        },
        cancelButtonText: {
            type: String,
            default: "",
        },
        item: Object,
        title: String,
        row: Object,
        btnClassName: String,
    },
    methods: {
        confirm() {
            this.$emit("rowDo", this.item, this.row);
        },
    },
};
</script>

<style lang="scss" scoped>
.delPopConfirm {
    max-width: 200px;
}
</style>>
